// MUST be first: restores BsDropdownModule.forRoot() for ngx-intl-tel-input,
// which calls it at module-evaluation time. See the file for the full rationale.
import './ngx-bootstrap-forroot-shim';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.log(err));
